import React from "react"
import { CLOSE_MODAL_TEXT, ERROR_MODAL_TITLE_TEXT } from "../../constants"
import { Modal } from "../../UIKit/components"
import {
  ModalBodyWrapper,
  ParagraphText,
  PrimaryButton,
} from "../../UIKit/styles"

export default function ErrorModal({ error, onClose }) {
  return (
    <Modal
      isOpen={error ? true : false}
      title={ERROR_MODAL_TITLE_TEXT}
      body={
        <ModalBodyWrapper>
          <ParagraphText>{error}</ParagraphText>
          <PrimaryButton onClick={onClose}>{CLOSE_MODAL_TEXT}</PrimaryButton>
        </ModalBodyWrapper>
      }
      onClose={onClose}
      allowClose={true}
    />
  )
}
